import React from 'react';
import { Icon, Button, Card } from 'antd';
import { useNavigate } from "react-router-dom";
import { useDeleteServiceableUrlMutation } from './service';
import ServiceableUrlsTable from './table/ServiceableUrlsTable';
import LoaderCard from '../shared/LoaderCard';
import useFetchServiceableUrlsPage from './hooks/useFetchServiceableUrlsPage';
import useAddUrlAnalysisProcessWithNotification from '../process/hooks/useAddUrlAnalysisProcessWithNotification';
import { useFetchUrlClustersQuery } from '../urlClusters/service';
import AddServiceableUrlsButton from '../serviceableUrls/AddServiceableUrlsButton';


type Props = {
    websiteGuid: string;
};


export default function ServiceableUrls({ websiteGuid }: Props) {
    const navigate = useNavigate();
    const { serviceableUrls, isFetchingServiceableUrlsNextPage, isLoadingServiceableUrlsFirstPage, hasMore, handleLoadMore } = useFetchServiceableUrlsPage({ websiteGuid });
    const { data: urlClusters, isLoading: isLoadingUrlClusters } = useFetchUrlClustersQuery({ w_guid: websiteGuid });
    const [deleteServiceableUrl, { isLoading: isDeletingUrl }] = useDeleteServiceableUrlMutation();

    const { addUrlAnalysisProcess, isAddingUrlAnalysisProcess } = useAddUrlAnalysisProcessWithNotification();

    const handleCheckUrlClick = (urlGuid: string) => {
        addUrlAnalysisProcess(websiteGuid, urlGuid);
    };

    const handleDeleteUrlClick = (urlGuid: string) => {
        deleteServiceableUrl({ w_guid: websiteGuid, url_guid: urlGuid });
    };
    const isLoading = isLoadingServiceableUrlsFirstPage || isLoadingUrlClusters;

    return (
        <>
            {isLoading && <LoaderCard />}
            {!isLoading && (
                <Card
                    title={
                        <>
                            <Icon className="back-icon" onClick={() => navigate(-1)} type="arrow-left" style={{ marginRight: "8px" }} />
                            <strong>Monitored URLs</strong>
                        </>
                    }
                    extra={<AddServiceableUrlsButton websiteGuid={websiteGuid} />}
                >
                    <ServiceableUrlsTable
                        serviceableUrls={serviceableUrls}
                        urlClusters={urlClusters || []}
                        isCheckButtonLoading={isAddingUrlAnalysisProcess}
                        isDeleteButtonLoading={isDeletingUrl}
                        onCheck={handleCheckUrlClick}
                        onDelete={handleDeleteUrlClick}
                        showClusterLabel
                    />

                    {hasMore && (
                        <Button
                            type="primary"
                            size="small"
                            onClick={handleLoadMore}
                            loading={isFetchingServiceableUrlsNextPage}
                            style={{ marginTop: '24px' }}
                        >
                            Load more
                        </Button>
                    )}
                </Card>
            )}
        </>
    );
}
